import { NzbnEntitySearchResponse } from "Hooks/Api/apiBusinessNumber";
import { AbrOrAsicSearchResponse, AustralianEntitySearchBox } from "../../../JurisdictionBusinessEntitySearchBox/AustralianEntitySearchBox";
import { NewZealandEntitySearchBox } from "../../../JurisdictionBusinessEntitySearchBox/NewZealandEntitySearchBox";

type Props = {
	countryCode: string;
	lookupDetail?: {
		lookupMethod: "ABN" | "ACN" | "NCN";
		lookupValue: string;
	};
	updateDetail: (
		newValue: { lookupMethod: "ABN" | "ACN" | "NCN"; lookupValue: string },
		isValid: boolean,
		entityDetail?: AbrOrAsicSearchResponse | NzbnEntitySearchResponse,
	) => void;
	entityDetail?: AbrOrAsicSearchResponse | NzbnEntitySearchResponse;
}

export const SearchEntitySection: React.FunctionComponent<Props> = ({
	countryCode,
	entityDetail,
	lookupDetail,
	updateDetail
}) => {
	return (
		<>
			{countryCode === "AU" && (
				<AustralianEntitySearchBox
					lookupDetail={lookupDetail}
					updateDetail={updateDetail}
					entityDetail={entityDetail as AbrOrAsicSearchResponse}
				/>
			)}
			{countryCode === "NZ" && (
				<NewZealandEntitySearchBox
					lookupValue={lookupDetail?.lookupValue ?? ""}
					updateDetail={(value, isValid, selectedEntity) => {
						updateDetail({
							lookupMethod: "NCN",
							lookupValue: value
						}, isValid, selectedEntity);
					}}
					entityDetail={entityDetail as NzbnEntitySearchResponse}
				/>
			)}
		</>
	)
}